module.exports = __webpack_public_path__ + "f2f2de96e14a40255e93ab5fab29916b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/landing/header_two.jpg
// module id = 219
// module chunks = 1